<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="page template-padding " v-else-if="loaded" >
        
        <div class="row" >
            <div class="col-12" >
                <!-- SCRIPT -->
                <div>
                    <h3 class="h3 mb-2 mt-1" > Install tracking script </h3>
                    <div class="accordion" role="tablist">
                    <b-card no-body class="">
                        <b-card-header header-tag="header" class="p-2" role="tab">
                            <b-button to="#accordion-1" block v-b-toggle.accordion-1 variant="transparent" class="text-left" > <span class="mr-3" > <font-awesome-icon :icon="['fab', 'google']" /> </span> Install code with Google Tag Manager</b-button>
                        </b-card-header>
                        <b-collapse id="accordion-1" ref="accordion-1" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                
                                <b-card-text>
                                    Log into your Google Tab Manager account, you can use this <b-link href="https://tagmanager.google.com/">link</b-link>.
                                    <br><br>
                                    The go to tags and create a new tag.
                                    <br><br>
                                    Choose the tag type as Custom HTML.
                                </b-card-text>
                                
                                <b-card-text>
                                    Copy the script below and paste it inside the HTML block and click save.
                                    
                                    <div class="col-12 mt-2" >
                
    <pre id="script-tracker" class="prettyprint border-gray p-4 border-radius bg-color-graylight grayligher-border">
        &lt;script&gt;
            window.atlassSettings = {
                APPKEY: "{{data.organizationID}}",
                tags: 'primary',
            }
            var s = document.createElement("script");
            s.type = "text/javascript";
            s.src = "https://theatlass.com/t/t.min.js";
            document.head.appendChild(s);
        &lt;/script&gt;
    </pre>
                
                                        <button class="btn btn-copy" @click="copyScript( 'tracker' )" > <font-awesome-icon icon="copy"  class="cursor-pointer graymedium-color h4" ></font-awesome-icon> </button>
                                        
                                    </div>
                                    
                                </b-card-text>
                                
                                <b-card-text>
                                    Don't forget to submit the new change.
                                </b-card-text>
                                

                            </b-card-body>
                        </b-collapse>
                    </b-card>

                    <b-card no-body class="">
                        <b-card-header header-tag="header" class="p-2" role="tab">
                            <b-button to="#accordion-2"  block v-b-toggle.accordion-2 variant="transparent" class="text-left" ><span class="mr-3" > <font-awesome-icon :icon="['fab', 'wordpress-simple']" /> </span>Install code manually on Wordpress</b-button>
                        </b-card-header>
                        <b-collapse id="accordion-2" ref="accordion-2" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                
                                <b-card-text>
                                    Log into your Wordpress admin.
                                    <br><br>
                                    The go to Appearences -> Themes. Make sure the current theme is the selected one.
                                    <br><br>
                                    Then open the header.php file from the right hand side.
                                </b-card-text>
                                
                                <b-card-text>
                                    Copy the script below and paste it as high as you can within the HEAD tag ( <code> &lt;head&gt;&lt;/head&gt; </code> ).
                                    
                                    <div class="col-12 mt-2" >
                
    <pre id="script-tracker2" class="prettyprint border-gray p-4 border-radius bg-color-graylight grayligher-border">
        &lt;script&gt;
            window.atlassSettings = {
                APPKEY: "{{data.organizationID}}",
                tags: 'primary',
            }
            var s = document.createElement("script");
            s.type = "text/javascript";
            s.src = "https://theatlass.com/t/t.min.js";
            document.head.appendChild(s);
        &lt;/script&gt;
    </pre>
                
                                        <button class="btn btn-copy" @click="copyScript( 'tracker2' )" > <font-awesome-icon icon="copy"  class="cursor-pointer graymedium-color h4" ></font-awesome-icon> </button>
                                        
                                    </div>
                                    
                                </b-card-text>
                                
                                <b-card-text>
                                    Don't forget to save the file.
                                </b-card-text>
                                
                            </b-card-body>
                        </b-collapse>
                    </b-card>

                    <b-card no-body class="">
                        <b-card-header header-tag="header" class="p-2" role="tab">
                            <b-button to="#accordion-3"  block v-b-toggle.accordion-3 variant="transparent" class="text-left" ><span class="mr-3" > <font-awesome-icon :icon="['fa', 'store']" /> </span>Install code on your custom store </b-button>
                        </b-card-header>
                        <b-collapse id="accordion-3" ref="accordion-3" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                
                                <b-alert show variant="primary"> NOTICE! This should be handled by the developer who set up your website. </b-alert>
                                
                                <b-card-text>
                                    Create an if statement for logged in users vs logged out users. 
                                </b-card-text>
                                
                                <b-card-text>
                                    For logged out users, aka visitors, use the code below: 
                                </b-card-text>
                                
                                <b-card-text>
                                    Copy the script below and paste it as high as you can within the HEAD tag ( <code> &lt;head&gt;&lt;/head&gt; </code> ).
                                    
                                    <div class="col-12 mt-2" >
                
    <pre id="script-loggedout" class="prettyprint border-gray p-4 border-radius bg-color-graylight grayligher-border">
        &lt;script&gt;
            window.atlassSettings = {
                APPKEY: "{{data.organizationID}}",
                tags: 'primary',
            }
            var s = document.createElement("script");
            s.type = "text/javascript";
            s.src = "https://theatlass.com/t/t.min.js";
            document.head.appendChild(s);
        &lt;/script&gt;
    </pre>
                
                                        <button class="btn btn-copy" @click="copyScript( 'loggedout' )" > <font-awesome-icon icon="copy"  class="cursor-pointer graymedium-color h4" ></font-awesome-icon> </button>
                                        
                                    </div>
                                    
                                </b-card-text>
                                
                                <b-card-text>
                                    For logged in users, use the code below: 
                                </b-card-text>
                                
                                <b-card-text>
                                    Copy the script below and paste it as high as you can within the HEAD tag ( <code> &lt;head&gt;&lt;/head&gt; </code> ).
                                    
                                    <div class="col-12 mt-2" >
                
    <pre id="script-loggedin" class="prettyprint border-gray p-4 border-radius bg-color-graylight grayligher-border">
        &lt;script&gt;
            window.atlassSettings = {
                APPKEY: "{{data.organizationID}}",
                tags: 'primary',
                email: '%customer.email%', //Fill that with the actual customer's email
            }
            var s = document.createElement("script");
            s.type = "text/javascript";
            s.src = "https://theatlass.com/t/t.min.js";
            document.head.appendChild(s);
        &lt;/script&gt;
    </pre>
                
                                        <button class="btn btn-copy" @click="copyScript( 'loggedin' )" > <font-awesome-icon icon="copy"  class="cursor-pointer graymedium-color h4" ></font-awesome-icon> </button>
                                        
                                    </div>
                                    
                                </b-card-text>
                                
                                <b-card-text>
                                    Don't forget to save the file.
                                </b-card-text>
                                
                            </b-card-body>
                        </b-collapse>
                    </b-card>

                </div>
                </div>
                <!-- SCRIPT -->
                
                <!-- ADS -->
                
                <!-- 
                
                BING ADS
                https://help.ads.microsoft.com/#apex/ads/en/56799/2-500

                -->
                <div>
                    <h3 class="h3 mb-2 mt-5" > Set up tracking parameters for traffic: ads, campaigns </h3>
                    <div class="accordion" role="tablist">
                        <b-card no-body class="">
                            <b-card-header header-tag="header" class="p-2" role="tab">
                                <b-button to="#accordion-21"  block v-b-toggle.accordion-21 variant="transparent" class="text-left" > <span class="mr-3" > <font-awesome-icon :icon="['fab', 'facebook-f']" /> </span> Set up Facebook ads</b-button>
                            </b-card-header>
                            <b-collapse id="accordion-21" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                    <b-card-text> Go to your Facebook Ads Manager, and go to Ads tab.  </b-card-text>
                                    <b-card-text> Select all ads using the checkbox in the header and click on Edit ads. This will edit all ads, in bulk  </b-card-text>
                                    <br>
                                    <b-card-text> Copy this code <code v-pre > fbadid={{ad.id}}&fbadname={{ad.name}} </code> and paste it in the URL parameters field </b-card-text>
                                    <br>
                                    <b-card-text>
                                        If you have other parameters, such as <code v-pre > utm_campaign={{fb.campaign_name}}&source=facebook </code>, merge them by adding 
                                        <code v-pre > &fbadid={{ad.id}}&fbadname={{ad.name}} </code>
                                    </b-card-text>
                                    <br>
                                    <b-card-text> Don't forget to save the new change</b-card-text>
                                    <br>
                                    <b-alert show variant="danger">
                                        <b>IMPORTANT!</b>
                                        Keep in mind that this will send the ad into review, but it won't have any effect on your ad
                                    </b-alert>
                                    
                                </b-card-body>
                            </b-collapse>
                        </b-card>

                        <b-card no-body class="">
                            <b-card-header header-tag="header" class="p-2" role="tab">
                                <b-button to="#accordion-22"  block v-b-toggle.accordion-22 variant="transparent" class="text-left" > <span class="mr-3" > <font-awesome-icon :icon="['fab', 'google']" /> </span> Set up Google ads</b-button>
                            </b-card-header>
                            <b-collapse id="accordion-22" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                    <b-card-text> Go to your Google Ads Manager, and go to Ads section.  </b-card-text>
                                    <b-card-text> Click on the Tools icon and click on Scripts ( under Bulk Actions ) and click on the plus icon to create a new script. </b-card-text>
                                    <br>
                                    <b-card-text> Copy the code below and paste in the new script </b-card-text>
                                    
                                    <div class="col-12 mt-2" >

        <pre id="script-adwords-adname" class="prettyprint border-gray p-4 border-radius bg-color-graylight grayligher-border">
            function main() {
                var adIterator = AdsApp.ads().get();
                    while (adIterator.hasNext()) {
                    var ad = adIterator.next();
                    var adgroup = ad.getAdGroup().getName().replace(/[^a-zA-Z0-9- ]/g, "");
                    var campaign = ad.getCampaign().getName().replace(/[^a-zA-Z0-9- ]/g, "");
                    //var adHeadline = ad.getLongHeadline().replace(/[^a-zA-Z0-9- ]/g, "");
                    var adID = ad.getId();
                    var name = campaign + " " + adgroup+ " " + adID;
                    name = name.replace(/\s/g,'-');
                    //Logger.log( name );
                    ad.getCampaign().urls().setCustomParameters({adname:name});
                }
            }
        </pre>

                                        <button class="btn btn-copy" @click="copyScript( 'adwords-adname' )" > <font-awesome-icon icon="copy"  class="cursor-pointer graymedium-color h4" ></font-awesome-icon> </button>

                                    </div>
                             
                                    <b-card-text> Don't forget to name the script, for example "Atlass ad name generator" and click on save. Before navigating, make sure to click run. </b-card-text>
                                    <br>
                                    <b-card-text> Next, go to All campaigns, click on Settings button, then Account settings and open the tracking section.  </b-card-text>
                                    <br>
                                    <b-card-text> Copy this code <code v-pre > {lpurl}?gadid={creative}&gadname={_adname} </code> and paste it in the Tracking Template field </b-card-text>
                                    <br>
                                    <b-card-text> Don't forget to save the new change</b-card-text>
                                </b-card-body>
                            </b-collapse>
                        </b-card>

                        <b-card no-body class="">
                            <b-card-header header-tag="header" class="p-2" role="tab">
                                <b-button to="#accordion-23" block v-b-toggle.accordion-23 variant="transparent" class="text-left" > <span class="mr-3" > <font-awesome-icon :icon="['fab', 'mailchimp']" /> </span> Set up Email Tracking </b-button>
                            </b-card-header>
                            <b-collapse id="accordion-23" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                    <b-card-text> Go to your Email Service provider and edit the email templates in use. </b-card-text>
                                    <b-card-text> Edit the CTA link within the body of the email </b-card-text>
                                    <b-card-text> Add the tracking parameters to the existing link <code v-pre > ?atl_email=%lead.email%&atl_campaign=%email.subject% </code> </b-card-text>
                                    <b-card-text> First make sure you change the <code v-pre > %lead.email% </code> and <code v-pre > %email.subject% </code>, depending on your ESP </b-card-text>
                                    <br>
                                    
                                    <b-card-text> For MailChimp, use this: <code v-pre > ?atl_email=*|EMAIL|*&mc_cid=*|CAMPAIGN_UID|* </code> ( More details <a href="https://mailchimp.com/help/all-the-merge-tags-cheat-sheet/" target="_blank" > here </a> ) </b-card-text>
                                    
                                    <b-card-text> For ActiveCampaign, use this: <code v-pre > ?atl_email=%EMAIL%&ac_cid=%CAMPAIGNID% </code> ( More details <a href="https://help.activecampaign.com/hc/en-us/articles/220709307-Personalization-Tags" target="_blank" > here </a> ) </b-card-text> 
                                    
                                    <b-card-text> For Drip, use this: <code v-pre > ?atl_email={{subscriber.email}}&atl_campaign={{campaign.name}} </code> </b-card-text>
                                    <b-card-text> For GetResponse, use this: <code v-pre > ?atl_email=[[email]] </code> </b-card-text>
                                    <b-card-text> For ConvertKit, use this: <code v-pre > ?atl_email={{subscriber.email_address}} </code> </b-card-text>
                                    <b-card-text> For Klaviyo, use this: <code v-pre > ?atl_email={{email}} </code> </b-card-text>
                                    <b-card-text> For Aweber, use this: <code v-pre > ?atl_email={!email} </code> </b-card-text>
                                    
                                    <br>
                                    <b-card-text> Don't forget to save the new change</b-card-text>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>
                </div>
                <!-- ADS -->
                
                <!-- CONVERSIONS -->
                <div>
                    <h3 class="h3 mb-2 mt-5" > Set up conversions </h3>
                    <div class="accordion" role="tablist">
                        <b-card no-body class="">
                            <b-card-header header-tag="header" class="p-2" role="tab">
                                <b-button to="#accordion-31" block v-b-toggle.accordion-31 variant="transparent" class="text-left" > <span class="mr-3" > <font-awesome-icon :icon="['fa', 'anchor']" /> </span> Set up Conversion by Pixel</b-button>
                            </b-card-header>
                            <b-collapse id="accordion-31" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                    <b-card-text> Go to Setup -> Conversions and create a new conversion specifying the name and the price.  </b-card-text>
                                    <b-card-text> This will generate a conversion tag ( <code> $conversion-tag </code> )  </b-card-text>
                                    <b-card-text> Locate your thank you page and add the following script  </b-card-text>

                                    <div class="col-12 mt-2" >

        <pre id="script-trackerconversion" class="prettyprint border-gray p-4 border-radius bg-color-graylight grayligher-border">
            &lt;script&gt;
                window.atlassSettings = {
                    APPKEY: "{{data.organizationID}}",
                    tags: "$conversion-tag"
                }
                var s = document.createElement("script");
                s.type = "text/javascript";
                s.src = "https://theatlass.com/t/t.min.js";
                document.head.appendChild(s);
            &lt;/script&gt;
        </pre>

                                        <button class="btn btn-copy" @click="copyScript( 'trackerconversion' )" > <font-awesome-icon icon="copy"  class="cursor-pointer graymedium-color h4" ></font-awesome-icon> </button>

                                    </div>

                                    <b-card-text> Save and publish it to the web.  </b-card-text>

                                </b-card-body>
                            </b-collapse>
                        </b-card>

                        <b-card no-body class="">
                            <b-card-header header-tag="header" class="p-2" role="tab">
                                <b-button to="#accordion-32" block v-b-toggle.accordion-32 variant="transparent" class="text-left" > <span class="mr-3" > <font-awesome-icon :icon="['fa', 'code']" /> </span> Send Conversion via API </b-button>
                            </b-card-header>
                            <b-collapse id="accordion-32" accordion="my-accordion" role="tabpanel">
                                <b-card-body>

                                    <b-alert show variant="primary"> NOTICE! This should be handled by the developer who set up your website. </b-alert>

                                    <b-card-text> Locate your function that processed the order. </b-card-text>
                                    <b-card-text> Send a post request to <code> https://atls-293616.ew.r.appspot.com/order/add </code> containing the JSON code below. </b-card-text>
                                    <b-card-text> Depending on the programming languange, we set up some examples: </b-card-text>
                                    <b-card-text> Don't forget to change the fields with the actual customer data.  </b-card-text>

                                    <!-- START API -->
                                    <b-card no-body class="atlass-tabs atlass-tabs-colored" >
                        <b-tabs card>

                            <b-tab title="Raw JSON" active>
                                <b-card-text  >

        <pre id="script-json" class="prettyprint mb-0 ">
            {
              "APPKEY": "{{data.organizationID}}", // Organization APPKEY, *required
              "APP_SECRET": "{{APP_SECRET}}", // Organization SECRET, *required
              "firstname": "John", //Client firstname
              "lastname": "Doe", //Client lastname
              "email": "John@doe.com", //Client email, *required
              "IP": "71.23.54.682", //Client IP
              "orderName": "Order number 215645675733",
              "orderPrice": "349",
              "orderItems": [
                { 
                    "Name": "produs test 1" , 
                    "price":299
                }
                ...
              ]
            }
        </pre>

                                    <button class="btn btn-copy mt-5" @click="copyScript( 'json' )" > <font-awesome-icon icon="copy"  class="cursor-pointer graymedium-color h4" ></font-awesome-icon> </button>

                                </b-card-text>
                            </b-tab>

                            <b-tab title="PHP" >
                                <b-card-text  >

        <pre id="script-php" class="prettyprint mb-0 ">
            $data = array(
                "APPKEY" => "{{data.organizationID}}", // Organization APPKEY, *required
                "APP_SECRET" => "{{APP_SECRET}}", // Organization SECRET, *required
                "firstname" => "John", //Client firstname
                "lastname" => "Doe", //Client lastname
                "email" => "john.doe@gmail.com", //Client email, *required
                "IP" =>  "71.23.54.682", //Client IP
                "orderName" => "Order number 215645675733", //Order name, Purchase name or Product name 
                "orderPrice" => 349, //Order price, Purchase price or Product price 
                "orderItems" => array( 
                    array( 
                        "Name" => "Item one",
                        "Price" => 349
                    ) 
                )
            );

            $payload = json_encode($data);

            // Prepare new cURL resource
            $ch = curl_init('https://tracker-288417.ew.r.appspot.com/order/add');
            curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
            curl_setopt($ch, CURLINFO_HEADER_OUT, true);
            curl_setopt($ch, CURLOPT_POST, true);
            curl_setopt($ch, CURLOPT_POSTFIELDS, $payload);

            // Set HTTP Header for POST request 
            curl_setopt($ch, CURLOPT_HTTPHEADER, array(
                'Content-Type: application/json',
                'Content-Length: ' . strlen($payload))
            );

            // Submit the POST request
            $result = curl_exec($ch);

            // Close cURL session handle
            curl_close($ch);

            var_dump( $result );
        </pre>

                                        <button class="btn btn-copy mt-5" @click="copyScript( 'php' )" > <font-awesome-icon icon="copy"  class="cursor-pointer graymedium-color h4" ></font-awesome-icon> </button>

                                </b-card-text>
                            </b-tab>

                            <b-tab title="Node.js" class="d-none"  >



                            </b-tab>

                            <b-tab title="Java" class="d-none"  >



                            </b-tab>

                        </b-tabs>
                    </b-card>
                                    <!-- END API -->
                                    <br>
                                    <b-card-text> Save the page and publish it. </b-card-text>

                                </b-card-body>
                            </b-collapse>
                        </b-card>

                    </div>
                </div>
                <!-- CONVERSIONS -->
                
                <!-- INTEGRATIONS -->
                <div>
                    <h3 class="h3 mb-2 mt-5" > Integrations </h3>
                    <div class="accordion" role="tablist">
                        <b-card no-body class="">
                            <b-card-header header-tag="header" class="p-2" role="tab">
                                <b-button to="#accordion-41"  block v-b-toggle.accordion-41 variant="transparent" class="text-left" > <span class="mr-3" > <font-awesome-icon :icon="['fab', 'facebook-f']" /> </span> Facebook </b-button>
                            </b-card-header>
                            <b-collapse id="accordion-41" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                    <b-card-text> Coming soon... </b-card-text>
                                </b-card-body>
                            </b-collapse>
                        </b-card>

                        <b-card no-body class="">
                            <b-card-header header-tag="header" class="p-2" role="tab">
                                <b-button to="#accordion-42"  block v-b-toggle.accordion-42 variant="transparent" class="text-left" > <span class="mr-3" > <font-awesome-icon :icon="['fab', 'google']" /> </span> Google Adwords </b-button>
                            </b-card-header>
                            <b-collapse id="accordion-42" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                    <b-card-text> Coming soon... </b-card-text>
                                </b-card-body>
                            </b-collapse>
                        </b-card>

                        <b-card no-body class="">
                            <b-card-header header-tag="header" class="p-2" role="tab">
                                <b-button to="#accordion-43"  block v-b-toggle.accordion-43 variant="transparent" class="text-left" > <span class="mr-3" > <font-awesome-icon :icon="['fab', 'wordpress-simple']" /> </span> WooCommerce </b-button>
                            </b-card-header>
                            <b-collapse id="accordion-43" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                    <b-card-text> Coming soon... </b-card-text>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>
                </div>
                <!-- INTEGRATIONS -->
                
            </div>
        </div>
        
    </div>
</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import helper from '@/helpers/helpers.js';

export default {
    name: 'Instructions',
    components:{
        
    },
    props: {
    },
    data: function(){
        return {
            loaded: false,
            data:{},
            APP_SECRET: ""
            
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        
        //this.get_data();
        
        let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
        this.data.organizationID = orgID;
        
        this.get_data()
        
        setTimeout(function(){ this.loaded = true;  }.bind(this), 100 );
        
        //let accordianName = this.$route.hash
        //accordianName = accordianName.replace(/[^a-zA-Z0-9- ]/g, "");
        //console.log( accordianName )
        //console.log( this.$refs )
        //this.$refs[accordianName].visible = true
        
    },
    beforeDestroy() {
    },
    methods: {
         get_data(){

            const db = firebase.firestore();
            var ref = db.collection('organizations').doc( this.data.organizationID )
            
            return ref.get()
            .then((snapshot) => {
                //console.log(snapshot.data().SECRET_KEY)
                this.APP_SECRET = snapshot.data().SECRET_KEY;
                return this.APP_SECRET
            })
          
        },
        formatData(unix){
            return this.$moment.unix(unix).format( 'MMM D, HH:mm' )
        },
        routePrimaryLead(ID){
            this.$router.push({
                name: 'LeadPage',
                params: { ID: ID }
            });
        },
        submit(){
            console.log( this.data )
        },
        copyScript( type ){
            
            var range = document.createRange();
            range.selectNode(document.getElementById("script-"+type));
            window.getSelection().removeAllRanges(); // clear current selection
            window.getSelection().addRange(range); // to select text
            document.execCommand("copy");
            window.getSelection().removeAllRanges();// to deselect
            
            this.$toast.success({
                title:'Success',
                message:  'Copied to clipboard!'
            })
            
        }
    },
    watch: {
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
    .btn-copy{
        position: absolute;
        top: 0;
        right: 15px;
    }
    
</style>



// WEBPACK FOOTER //
// src/templates/setup/Instructions.vue